import { Route, Routes } from 'react-router-dom';
import { Dashboard } from '../../pages/dashboard/Dashboard';
import { PatientList } from '../../pages/patientList/PatientList';
import { Commissioning } from '../../pages/commissioning/Commissioning';
import { MachineSpec } from '../../pages/machineSpec/MachineSpec';
import { Patient } from '../../pages/patient/Patient';
import { Service } from '../../pages/service/Service';
import { AuditTrail } from '../../pages/auditTrail/AuditTrail';
import { PopupMessage, Section } from '../../shared/types/types';
import { BannerMessages } from '../errors/banners/BannerMessages';
import { BannerMessage } from '../../shared/contexts/BannerMessageContext';
import './Main.scss';
import { PopupMessages } from '../Popups/PopupMessages';
import { InfusionList } from 'src/pages/infusionList/InfusionList';
import { PatientCheckIn } from 'src/pages/patientCheckIn/PatientCheckIn';
import { Infusion } from 'src/pages/infusion/Infusion';
import { Planning } from 'src/pages/planning/Planning';
import { IdToken } from '@auth0/auth0-react';

export interface MainProps {
  section: Section;
  onSectionClick: (section: Section) => void;
  onInfusionLoad: () => any;
  bannerMessages: BannerMessage[];
  onCloseBanner: (id: string) => void;
  popupMessages: PopupMessage[];
  onClosePopup: (id: string) => void;
  userAuthenticated: IdToken | null;
  token: string | null;
  onPrem: boolean;
}

export function Main({ section, onSectionClick, onInfusionLoad, bannerMessages, onCloseBanner, popupMessages, onClosePopup, token, onPrem }: MainProps) {
  return (
    <section className="main-content">
      <BannerMessages messages={bannerMessages} onCloseBanner={onCloseBanner} />
      <PopupMessages messages={popupMessages} onClosePopup={onClosePopup} />
      <Routes>
        {<Route path="/" element={<Dashboard onSectionClick={onSectionClick} onPrem={onPrem} />} />}
        {!onPrem && <Route path="/records" element={<PatientList section={section} token={token} />} />}

        {onPrem && <Route path="/infusion" element={<InfusionList section={section} token={token} />} loader={onInfusionLoad} />}
        {!onPrem && <Route path="/commissioning/" element={<Commissioning token={token} />} />}
        {!onPrem && <Route path="/machine-spec/" element={<MachineSpec />} />}
        {<Route path="/patients/:id" element={<Patient section={section} token={token} />} />}
        {onPrem && <Route path="/infusions/:id" element={<Infusion section={section} token={token} />} />}
        {onPrem && <Route path="/checkin/:id" element={<PatientCheckIn section={section} token={token} />} />}
        {!onPrem && <Route path="/service" element={<Service token={token} />} />}
        {!onPrem && <Route path="/planning" element={<Planning token={token} />} />}
        {!onPrem && <Route path="/audit-trail" element={<AuditTrail token={token} />} />}
      </Routes>
    </section>
  );
}
